<div class="container-fluid" *ngIf="isCheckingUrl || isValidUrl">
  <div class="row" role="banner" aria-label="Header" *ngIf="headerHtml">
    <div class="text-center" [innerHtml]="headerHtml"></div>
  </div>

  <router-outlet (activate)="setHeader()"></router-outlet>
</div>

<div class="centered-text" *ngIf="!isCheckingUrl && !isValidUrl">
  <h1>Incomplete URL. Please verify the web address that you are attempting to access.</h1>
</div>
